import { Link } from "react-router-dom"

const Navbar = () => {
  return (
    <nav className="flex flex-wrap flex-row items-center gap-6 text-sm m-12">
      <Link to="/">
        <img src = '/images/transparent.png' className="w-24" alt = 'app__logo' />
      </Link>
      <span className="nav__item">Invite Friends</span>
      <Link to="/business">
        <span className="nav__item">Business</span>
      </Link>
      <Link to="/privacy">
        <span className="nav__item">Privacy Policy</span>
      </Link>
    </nav>
  );
};

export default Navbar